import { render } from "./HeaderHome.vue?vue&type=template&id=70324a7e&scoped=true"
import script from "./HeaderHome.vue?vue&type=script&lang=js"
export * from "./HeaderHome.vue?vue&type=script&lang=js"

import "./HeaderHome.vue?vue&type=style&index=0&id=70324a7e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Test\\Desktop\\gthconsult-siteV2\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70324a7e"]])

export default __exports__